import React, { useState, useEffect, useContext } from 'react';
import { Box, Chip, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, CircularProgress } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import './vacation-bids.css'
import Modal from 'react-bootstrap/Modal';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import { Row , Col } from 'react-bootstrap';

const VacationBidMembers = () => {
    let { id } = useParams();
    const { user } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [bidList, setBidList] = useState([]);
    const [listModal, setListModal] = useState(false)
    const [vacationList, setVacationList] = useState([]);
    const [open, setOpen] = useState(false);
    const [rowData , setRowData] = useState([]);

    const columns = [
        {
            field: 'Id', headerName: 'Bid Id', flex: 1, minWidth: 200,
        },

        {
            field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    params?.row?.employee?.employee_assignment?.EA_Rank + " " + params?.row?.employee?.fullName
                )
            }
        },

        {
            field: 'Status', headerName: 'Status', flex: 1, minWidth: 200,
            renderCell: (params) => {
                return (
                    <Chip
                        sx={{
                            backgroundColor: params?.row?.Status == "pending" ? '#FFD32C' : '#000000',
                            color: '#FFFFFF',
                            cursor: 'pointer',
                            width: '100px'
                        }}
                        label={params?.row?.Status?.charAt(0).toUpperCase() + params?.row?.Status?.slice(1)}
                    />
                );
            }
        },

        {
            field: 'offer', headerName: 'Offer At', flex: 1, minWidth: 200,
            valueGetter: (params) => { return varFormatTime(params.row.Offered_At, user?.Time_Format) }
        },

        {
            field: 'action', headerName: 'Actions', flex: 1, minWidth: 130,
            renderCell: (params) => {
                return (
                    <>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                                <img src='/images/eye.svg' style={{ cursor: 'pointer' }} onClick={() => {
                                    getVacationMember(params?.row?.employee?.Emp_Code)
                                    setListModal(true)
                                }}
                            />
                        </Box> 
                        {params?.row?.Status == 'requested' && 
                            <ButtonTheme
                                className='px-2 mt-1'
                                style={{ marginLeft: '24px' }}
                                color='primary'
                                variant="filled"
                                onClick={() => 
                                {
                                    setOpen(true)
                                    setRowData(params?.row)
                                }}
                            >
                                Mark as Finished
                            </ButtonTheme>
                        }
                    </>
                );
            },
        }
    ]

    const ContinueBiddingByAdmin = (row) => {
        setLoading(true);
        ApiService.post("/vacationBid/continue-by-admin", {
          vacation_bid_id : row.Vacation_Bid_Id,
          emp_code : row.Emp_Code,
        })
          .then((data) => {
            setLoading(false);
            setOpen(false)
            getBidListMembers();
            toast.success(data?.message)
          })
          .catch((error) => {
            toast.error(error.data.message || error.message || 'error')
            setLoading(false);
          });
      };

    const getBidListMembers = () => {
        setLoading(true)
        ApiService.get(`/vacationBid/${id}`)
            .then((data) => {
                const rowsWithIds = data?.data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                setBidList(rowsWithIds);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    const getVacationMember = (vacId) => {
        ApiService.get(`/vacationBid/member/${vacId}/${id}`)
            .then((data) => {
                const rowsWithIds = data?.data?.data?.map((item, index) => ({
                    ...item,
                    id: index + 1
                })) || [];
                setVacationList(rowsWithIds);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getBidListMembers()
    }, [])

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            ) : (
                <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
                    <Grid container spacing={2}>

                        {/* Heading */}
                        <Grid item xs={10} md={9}>
                            <Typography variant="h5">
                                <Link to="/firehouse/vacation-bids" style={{ color: "black" }}>
                                    <ArrowBackIosIcon />
                                </Link>
                                Vacation Bid Members</Typography>
                        </Grid>
                    </Grid>

                    {(!bidList || bidList.length == 0) ?
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 600 }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                                No Bids Found
                            </span>
                        </div>
                        :
                        <>
                            <div className='mt-4'>
                                <DataGrid
                                    rows={bidList}
                                    columns={columns}
                                    checkboxSelection={false}
                                    hideFooter={true}
                                />
                            </div>
                        </>
                    }

                    {/* Vacation List Modal */}
                    <Modal size="lg" show={listModal}
                        onHide={() => {
                            setListModal(false)
                            setVacationList([])
                        }}>
                        <Modal.Body className='p-4'>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
                                    List of Vacations
                                </Typography>
                                <img src="/images/close-icon.svg" style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        setListModal(false)
                                        setVacationList([])
                                    }} />
                            </div>

                            <Box id="modal-modal-description" sx={{ mt: 2 }}>
                                {loading &&
                                    <div className='my-5' style={{ display: 'flex', justifyContent: 'center' }}>
                                        <CircularProgress />
                                    </div>
                                }

                                {!loading &&
                                    <div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
                                        <TableContainer component={Paper} sx={{
                                            boxShadow: 'none !important',
                                            border: '1px solid #EAECF0',
                                            mt: 2
                                        }}>

                                            <Table aria-label="customized table">
                                                <TableHead sx={{ backgroundColor: "#E5E9EB" }} >
                                                    <TableRow>
                                                        <TableCell>Shift Date</TableCell>
                                                        <TableCell>Shift</TableCell>
                                                        <TableCell>Start Time</TableCell>
                                                        <TableCell>End Time</TableCell>
                                                        <TableCell>Requested on</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {vacationList.length > 0 ? vacationList.map((row) => (
                                                        <TableRow key={row?.fullName} sx={{
                                                            height: '22px',
                                                            '& .MuiTableCell-root': {
                                                                border: 'none'
                                                            },
                                                            '&:nth-of-type(even)': {
                                                                backgroundColor: 'rgba(204, 204, 204, 0.2)',
                                                            },
                                                        }}>

                                                            <TableCell component="th" scope="row">
                                                                {moment(row?.Shift_Date).format('MM/DD/YYYY')}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {row?.shift?.Shift}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {row?.shift?.Start_Time}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {row?.shift?.End_Time}
                                                            </TableCell>

                                                            <TableCell component="th" scope="row">
                                                                {moment(row?.created_at).format('MM/DD/YYYY, HH:mm')}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                        :
                                                        <TableRow>
                                                            <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                                                                <div className='d-flex flex-column align-items-center justify-content-center' style={{ marginTop: 15 }}>
                                                                    <img src='/images/blur-logo.png' style={{ width: 115 }} />
                                                                    <span className='mt-4' style={{ color: '#555555' }}>
                                                                        No Vacations Found
                                                                    </span>
                                                                </div>
                                                            </TableCell>
                                                        </TableRow>
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                }
                            </Box>
                        </Modal.Body>
                    </Modal>
                </Paper >
            )}

            <Modal show={open} onHide={()=> setOpen(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Mark as Finished</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{ color: '#555555' }}>
                  You’re about to finish the bidding process for this user. Once the bidding ends, the next user—if they haven’t already requested—will be allowed to place bids.
                </div>
                <Row>
                  <Col md='auto'>
                    <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={()=> setOpen(false)}>
                      Cancel
                    </ButtonTheme>
                  </Col>
                  <Col md='auto'>
                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => ContinueBiddingByAdmin(rowData)}>
                      Confirm
                    </ButtonTheme>
                  </Col>
                </Row>
              </Modal.Body>
              </Modal>
        </>
    )
}

export default VacationBidMembers